import { DocumentSearchResult } from './DocumentSearch.types';

export function formatReferenceCountMessage(
  annotations: DocumentSearchResult[] | undefined,
  searchQuery: string
): string {
  const count = annotations?.length ?? 0;
  const hasQuery = searchQuery && searchQuery.trim().length > 0;

  if (count === 0) {
    return 'No references found';
  }

  if (count === 1) {
    return hasQuery
      ? `1 reference found for "${searchQuery}"`
      : '1 reference found';
  }

  return hasQuery
    ? `${count} references found for "${searchQuery}"`
    : `${count} references found`;
}
